var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{attrs:{"value":_vm.active},on:{"tab-click":_vm.handleTabClick}},_vm._l((_vm.tabs),function(tab){return _c('el-tab-pane',{key:tab.id,attrs:{"label":tab.name,"name":tab.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }